<template>

    <BnOffsetCard :blockTitle="titleExtra + ' egyéb adatok'">

        <div slot="block-elements">

            <slot name="biztositoi-adatok" />

        </div>

    </BnOffsetCard>

</template>

<script>

export default {
    name: 'AjanlatBase',
    props: {
        titleExtra: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
};
</script>
